import {Injectable} from '@angular/core';
import {TOOL} from './map';

@Injectable({
    providedIn: 'root'
})
export class UtilitiesFn {

    constructor() {
    }

    createTool(tool: TOOL, eventFunc: any): HTMLButtonElement {

        // Create button
        const btn: HTMLButtonElement = document.createElement('button');
        btn.type = 'button';
        btn.title = tool.name;
        btn.id = tool.code;
        btn.onclick = eventFunc;
        // btn.className = `mapbox-gl-draw_ctrl-draw-btn ${tool.className ? tool.className : ''}`;

        // Create icon
        if (tool.iconClass) {
            const icon: any = document.createElement('i');
            icon.className = tool.iconClass;
            if (icon.className === 'esri-icon esri-icon-chart') {
                icon.style.fontWeight = '600';
            }
            if (tool.className) {
                icon.innerHTML = tool.className;
                icon.style.paddingTop = '5px';
                icon.style.fontWeight = '500';
                icon.style.fontSize = '18px';
                icon.style.color = 'black';
                if (tool.className === 'explore' || tool.className === 'info' || tool.className === 'layers' ) {
                    icon.style.paddingTop = '4.5px';
                    icon.style.fontSize = '20px';
                } else if (tool.className === 'pentagon' || tool.className === 'map') {
                    icon.style.paddingTop = '4.5px';
                    icon.style.fontSize = '20px';
                }else if (tool.className === 'delete') {
                    icon.style.paddingTop = '4px';
                    icon.style.fontSize = '22px';
                }
            }
            btn.appendChild(icon);
        }

        return btn;
    }

    createControl(tools: any, containerClass: string): HTMLDivElement {

        // Create container
        const container = document.createElement('div');
        container.className = `mapboxgl-ctrl-group mapboxgl-ctrl ${containerClass}`;

        if (!document.getElementsByClassName(containerClass).length) {
            // Add tool into container
            tools.map((tool: any) => {
                container.appendChild(tool);
            });
        }

        return container;
    }

    getByKey(items: any[], keyColumn: string, valueColumn: any): any {
        const result: any = {};
        items.map(item => {
            if (item[keyColumn] && item[valueColumn]) {
                result[item[keyColumn]] = item[valueColumn];
            }
        });
        return result;
    }

    // Is json string
    isJsonString(str: string): boolean {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    // Is numeric
    isNumeric(num: any): boolean {
        return !isNaN(num);
    }

    toSlug(str: string, replaceStr: string = '-'): string {

        // Chuyển hết sang chữ thường
        str = str.toLowerCase();

        // xóa dấu
        str = str
            .normalize('NFD') // chuyển chuỗi sang unicode tổ hợp
            .replace(/[\u0300-\u036f]/g, ''); // xóa các ký tự dấu sau khi tách tổ hợp

        // Thay ký tự đĐ
        str = str.replace(/[đĐ]/g, 'd');

        // Xóa ký tự đặc biệt
        str = str.replace(new RegExp('([^0-9a-z' + replaceStr + '\\s])', 'g'), '');

        // Xóa khoảng trắng thay bằng ký tự -
        str = str.replace(/(\s+)/g, replaceStr);

        // Xóa ký tự - liên tiếp
        str = str.replace(new RegExp(replaceStr + '+', 'g'), replaceStr);

        // xóa phần dư - ở đầu & cuối
        str = str.replace(new RegExp('^' + replaceStr + '+|' + replaceStr + '+$', 'g'), '');

        // return
        return str;
    }
}
